import { css } from 'styled-components';

export default css`
  margin-top: 1em;
  padding: 0 2em;
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
